import ContentPage from '@/components/feature/ContentPage';

export default function AboutPage() {
  return (
    <ContentPage
      title="About CSSBuyBR.TOP"
      metaTitle="About CSSBuyBR.TOP — Independent CSSBuy Resource | CSSBuyBR"
      metaDescription="CSSBuyBR.TOP is an independent resource for CSSBuy spreadsheet guides, product categories, reviews and shipping information. Not affiliated with CSSBuy."
      subtitle="An independent resource center helping shoppers navigate CSSBuy with organized information, guides, and safety tips."
      content={
        <div className="space-y-6">
          <section>
            <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-900 mb-3">What We Do</h2>
            <p>CSSBuyBR.TOP is an independent resource website designed to help users find, compare, and organize CSSBuy products and information. We provide:</p>
            <ul className="list-disc list-inside space-y-1.5 ml-2 mt-2">
              <li>Organized product category guides</li>
              <li>Informative articles about CSSBuy processes</li>
              <li>Shipping cost explanations and guidance</li>
              <li>Safety tips for avoiding scams and fake links</li>
              <li>Comparison resources for better shopping decisions</li>
              <li>Multilingual content in Portuguese, English, and German</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-900 mb-3">Our Independence</h2>
            <p><strong>CSSBuyBR.TOP is an independent resource and is not affiliated with, sponsored by, or officially endorsed by CSSBuy.</strong></p>
            <p className="mt-2">We do not represent CSSBuy or any of its partners. All information provided on this site is for educational and research purposes. We encourage users to verify all information directly with official sources before making any purchasing decisions.</p>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-900 mb-3">Content Policy</h2>
            <p>Our content is created independently to help users make informed decisions. We:</p>
            <ul className="list-disc list-inside space-y-1.5 ml-2 mt-2">
              <li>Do not guarantee any specific search rankings or outcomes</li>
              <li>Do not fabricate reviews, ratings, or product data</li>
              <li>Do not list specific coupon codes or current prices (these change frequently)</li>
              <li>Update content periodically to reflect current information</li>
              <li>Encourage users to verify all details with official sources</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-900 mb-3">Languages</h2>
            <p>This website is available in three languages to serve a broad international audience:</p>
            <div className="grid sm:grid-cols-3 gap-3 mt-4">
              <div className="p-4 rounded-xl bg-background-100 border border-background-200/70 text-center">
                <p className="text-sm font-semibold text-foreground-800">Português</p>
                <p className="text-xs text-foreground-500 mt-1">Primary language</p>
              </div>
              <div className="p-4 rounded-xl bg-background-100 border border-background-200/70 text-center">
                <p className="text-sm font-semibold text-foreground-800">English</p>
                <p className="text-xs text-foreground-500 mt-1">International</p>
              </div>
              <div className="p-4 rounded-xl bg-background-100 border border-background-200/70 text-center">
                <p className="text-sm font-semibold text-foreground-800">Deutsch</p>
                <p className="text-xs text-foreground-500 mt-1">German</p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-900 mb-3">Disclaimer</h2>
            <p>All content on this site is provided for informational purposes only. We do not make absolute claims about the legitimacy, safety, or quality of any third-party service. Users are responsible for conducting their own research and making informed decisions. Always verify information directly with official sources before making purchases or sharing personal information.</p>
          </section>
        </div>
      }
    />
  );
}